import { TFunction } from '@lyearn/i18n';
import { getRequestType } from '@lyearn/lygo-core';

import { languagesMap } from '../components/Subtitle/consts';
import { CaptionMap } from '../components/Subtitle/types';

export const getCloudflareStreamingIdFromUploadResponse = (bodyUrl: string) => {
  // bodyUrl will be in format
  // https://api.cloudflare.com/client/v4/accounts/{ACCOUNT_ID}/media/{STREAM_ID}?tusv2=true
  const prefix = 'tus/';
  return bodyUrl.substring(
    bodyUrl.lastIndexOf(prefix) + prefix.length,
    bodyUrl.lastIndexOf('?tusv2'),
  );
};

export const getCloudflareRequestURL = (streamID: string) =>
  `/external/api/cloudflare/streamDetails?streamId=${streamID}`;

export const getCloudflareStreamingIdFromVideoSrc = (bodyUrl: string) => {
  return new URL(bodyUrl).pathname.split('/')?.[1];
};

// todo remove function after backend migration
export const replaceURLHost = (url: string) => {
  // For some regions, cloudflare faces problems serving the video.
  // So need to switch the host from URL.
  // https://community.cloudflare.com/t/videos-stream-dont-play-from-spain-and-yes-by-a-vpn/380175/4
  const newPrefix = 'https://customer-8kboz44wkx5558ew.cloudflarestream.com';
  return url
    .replace('https://videodelivery.net', newPrefix)
    .replace('https://cloudflarestream.com', newPrefix);
};

export const getTracks = (captions: CaptionMap, disabedCaptions: string[], t: TFunction) => {
  const tracks = [];
  for (const [key, value] of Object.entries(captions)) {
    if (!disabedCaptions.includes(key)) {
      tracks.push({
        label: t(languagesMap.find((language) => language.value === key)?.label as string),
        srcLang: key,
        src: value,
      });
    }
  }
  return tracks;
};
interface ResumeProcessingProps {
  streamId: string;
  updateAttrs: (attrs: Object) => void;
  getRequest?: getRequestType;
  getCloudflareRequestURL: (streamID: string) => string;
}

export const resumeVideoProcessing = (props: ResumeProcessingProps) => {
  const { streamId, updateAttrs, getRequest, getCloudflareRequestURL } = props;
  getRequest?.(getCloudflareRequestURL(streamId))
    .then((res: any) => {
      if (res?.data?.playback?.dash) {
        updateAttrs({
          src: res.data.playback.dash,
        });
      } else {
        updateAttrs({
          processing: null,
          streamId: null,
        });
      }
    })
    ?.catch((err: any) => {
      updateAttrs({
        processing: null,
        streamId: null,
      });
    });
};
